import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  
  	.sr-hidden {
		opacity: 0;
		transform: translateY(20px);
		transition: opacity .7s ease, transform .7s ease;
	}

	.sr-visible {
		opacity: 1;
		transform: translateY(0);
	}

    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box
    }

    a{
        text-decoration: none
    }

    *:focus {
        outline: none;
    }

    html{
        scroll-behavior: smooth;
        margin: 0;
        padding: 0;
		background-color: #80edff;
    }	


    body{
        font-family: "Barlow", serif!important;
		-webkit-font-smoothing: antialiased;
  		-moz-osx-font-smoothing: grayscale;
		 text-rendering: optimizeLegibility;
        font-optical-sizing: auto;
        font-weight: 400;
        font-style: normal;
		
    }

    h1, h2, h3, h4, h5, h6, strong{
        font-weight: 600;
    }
 
    .mb{
        display: none
    }

    .pc{
        display: inline-block
    }

    .fullContent{
        max-width: 1920px;
        width: 100%; 
        margin: 0 auto;
        position: relative;
        padding: 0 1%;
    }

    .img{
        width: 100%;
        height: auto
    }	

	.p-dialog .p-dialog-header{
		padding: 10px !important
	}

	iframe{
		border: none
	}

	.p-component{
		font-family: "Barlow", serif;
		font-weight: 300
	}

	.container {
		max-width: 1366px;
		width: 100%;  /* Largura fixa */
		margin: 0 auto;  /* Centraliza horizontalmente */
		padding: 0 20px; /* Adiciona um pequeno espaço nas laterais para evitar que o conteúdo fique colado */
	}

	.barlow-thin {
		font-family: "Barlow", sans-serif;
		font-weight: 100;
		font-style: normal;
	}

	.barlow-extralight {
		font-family: "Barlow", sans-serif;
		font-weight: 200;
		font-style: normal;
	}

	.barlow-light {
		font-family: "Barlow", sans-serif;
		font-weight: 300;
		font-style: normal;
	}

	.barlow-regular {
		font-family: "Barlow", sans-serif;
		font-weight: 400;
		font-style: normal;
	}

	.barlow-medium {
		font-family: "Barlow", sans-serif;
		font-weight: 500;
		font-style: normal;
	}

	.barlow-semibold {
		font-family: "Barlow", sans-serif;
		font-weight: 600;
		font-style: normal;
	}

	.barlow-bold {
		font-family: "Barlow", sans-serif;
		font-weight: 700;
		font-style: normal;
	}

	.barlow-extrabold {
		font-family: "Barlow", sans-serif;
		font-weight: 800;
		font-style: normal;
	}

	.barlow-black {
		font-family: "Barlow", sans-serif;
		font-weight: 900;
		font-style: normal;
	}

	.barlow-thin-italic {
		font-family: "Barlow", sans-serif;
		font-weight: 100;
		font-style: italic;
	}

	.barlow-extralight-italic {
		font-family: "Barlow", sans-serif;
		font-weight: 200;
		font-style: italic;
	}

	.barlow-light-italic {
		font-family: "Barlow", sans-serif;
		font-weight: 300;
		font-style: italic;
	}

	.barlow-regular-italic {
		font-family: "Barlow", sans-serif;
		font-weight: 400;
		font-style: italic;
	}

	.barlow-medium-italic {
		font-family: "Barlow", sans-serif;
		font-weight: 500;
		font-style: italic;
	}

	.barlow-semibold-italic {
		font-family: "Barlow", sans-serif;
		font-weight: 600;
		font-style: italic;
	}

	.barlow-bold-italic {
		font-family: "Barlow", sans-serif;
		font-weight: 700;
		font-style: italic;
	}

	.barlow-extrabold-italic {
		font-family: "Barlow", sans-serif;
		font-weight: 800;
		font-style: italic;
	}

	.barlow-black-italic {
		font-family: "Barlow", sans-serif;
		font-weight: 900;
		font-style: italic;
	}


	#md{
		max-width: 1024px;
	}

	#lg{
		max-width: 1280px;
	}

	.detailVideos{
		padding: 20px;
	}

	.p-tabview .p-tabview-nav li{
		padding: 0 20px;
	}

	.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link
	{
	    color: #ff3b2f!important;
		border-color: #ff3b2f;
	}
		
	.p-tabview .p-tabview-nav{
	    border-width: 0 0 0 0;
	}

	.caseTop {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 20px;
		position: fixed;
		bottom: 5%;
		z-index: 20;
	}

	.caseNav {
		min-width: 100px;
		height: 32px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 6px;
		position: relative;
		padding: 0 15px;
		box-sizing: border-box;
		color: #d94a43;
		font-size: 14px;
		line-height: 1;
		font-weight: 600;
		letter-spacing: -0.03em;
		text-decoration: underline;
		text-underline-offset: 2px;
		background: transparent;
		transition: transform 0.3s ease;
	}

	.caseNav span,
	.caseNav img {
		position: relative;
		z-index: 3;
	}

	.caseNav img {
		width: 12px;
		height: auto;
		display: block;
		filter: brightness(0) saturate(100%) invert(39%) sepia(52%) saturate(1573%)
			hue-rotate(327deg) brightness(97%) contrast(86%);
		transition: transform 0.3s ease;
		display: none
	}

	/* seta anterior */
	.caseNavHome img {
		transform: rotate(180deg);
	}

	/* botão anterior - formato igual ao print */
	.caseNavHome::before {
		content: "";
		position: absolute;
		inset: 0;
		background: #d94a43;
		clip-path: polygon(10px 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
		z-index: 1;
	}

	.caseNavHome::after {
		content: "";
		position: absolute;
		inset: 1px;
		background: #fff7df;
		clip-path: polygon(10px 0, 100% 0, calc(100% - 10px) 100%, 0 100%);
		z-index: 2;
	}

	/* próximo - espelhado */
	.caseNavNext::before {
		content: "";
		position: absolute;
		inset: 0;
		background: #d94a43;
		clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 100%, 10px 100%);
		z-index: 1;
	}

	.caseNavNext::after {
		content: "";
		position: absolute;
		inset: 1px;
		background: #fff7df;
		clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 100%, 10px 100%);
		z-index: 2;
	}

	.caseNav:hover {
		transform: translateY(-1px);
	}

	.caseNavHome:hover img {
		transform: rotate(180deg) translateX(2px);
	}

	.caseNavNext:hover img {
		transform: translateX(2px);
	}

	@media (max-width: 520px) {
		.caseNav {
			min-width: 102px;
			height: 28px;
			font-size: 13px;
			padding: 0 14px;
		}

		.caseNav img {
			width: 10px;
		}
	}

	

	#modalBlue{
		background: #80edff;

		.p-dialog-header, .detailVideos, .p-tabview-nav{
			background: #80edff;
		}

		.p-tabview-nav{
		 a{
			 background: #80edff;
			 color: #333;
		 }
		}

		.m-0{
			padding: 20px;
			background: #80edff;
		}

	}


    @media only screen and (max-width: 1024px) {
        .fullContent{        
            padding: 2%;        
        }

    }



    @media only screen and (max-width: 800px) {
     
        .mb{
            display: inline-block
        }

        .pc{
            display: none
        }
        
    }

    @media only screen and (max-width: 480px) {

		.container{
			padding: 0 10px;
		}
       
    }



`;
